import axios from 'axios';

const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;

export default {
    GetBranchPage(orgid) {
        return axios.get(API_ENDPOINT + "api/LOWebsites/GetBranchPage?orgid=" + orgid);
    },
    GetLOInfoByOrgID(orgid) {
        return axios.get(API_ENDPOINT + "api/LOWebsites/GetLOInfoByOrgID?orgId=" + orgid);
    },
    GetOrgIdAndAddressByState(state) {
        return axios.get(API_ENDPOINT + "api/LOWebsites/GetOrgIdAndAddressByState?state=" + state);
    },
    post(url, data) {
        return axios.post(API_ENDPOINT + url, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
};
